import React from 'react';
import classNames from 'classnames';
import './Navigation.scss';

const NavigationWrapper = ({ children }) => {
  return <div className={classNames('c-nav__wrapper')}>{children}</div>;
};

export default NavigationWrapper;
